import TextThumbIcon from '../../common/icons/TextThumbIcon'
import ImageThumbIcon from '../../common/icons/ImageThumbIcon'
import ShapesIcon from '../../common/icons/ShapesIcon'
import {NODE_TYPES} from './nodeTypes'

export const NODE_LAYER_SELECT_KEYS = ['Enter', ' ']
export const NODE_LAYER_ACTION_ICON_SIZE = 16
export const NODE_LAYER_THUMBNAIL_ICON_SIZE = 24
export const NODE_LAYER_DEFAULT_TITLE = 'Node'
export const NODE_LAYER_DEFAULT_SUBTITLE = ''
export const NODE_LAYER_IMAGE_PREVIEW_STYLE = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: 'inherit',
}

export const NODE_LAYER_PRESENTATION = {
    [NODE_TYPES.TEXT]: {
        defaultTitle: 'Text',
        listSubtitle: 'Text node',
        toolboxSubtitle: 'text',
        thumbnailIcon: TextThumbIcon,
    },
    [NODE_TYPES.IMAGE]: {
        defaultTitle: 'Image',
        listSubtitle: 'Image node',
        toolboxSubtitle: 'image',
        thumbnailIcon: ImageThumbIcon,
    },
    [NODE_TYPES.SVG_SHAPE]: {
        defaultTitle: 'Basic Shape',
        listSubtitle: 'Shape node',
        toolboxSubtitle: 'basic shape',
        thumbnailIcon: ShapesIcon,
    },
}
